import React, { useEffect, useState } from "react";
import { startCapture, finishCapture } from "../../../actions";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ROUTES from "../../AppRouter/routes";
import TrayViewer from "./TrayViewer";

const CaptureTray = ({ startCapture, selectedDevice }) => {
  const history = useHistory();
  const [sentCapture, setSentCapture] = useState(false);

  useEffect(() => {
    const loadTray = async () => {
      if (!selectedDevice) {
        history.push(ROUTES.traysTab);
      }
      if (!sentCapture) {
        await startCapture(selectedDevice);
        setSentCapture(true);
      }
    };
    loadTray();
  }, [history, selectedDevice, sentCapture, startCapture]);

  useEffect(() => {
    if (sentCapture) {
      return () => {
        finishCapture();
      };
    }
  }, [sentCapture]);

  return (
    <TrayViewer />
  );
};

export const mapStateToProps = (state) => {
  const { selectedDevice } = state.devices;
  if (!selectedDevice) return {};

  return {
    selectedDevice,
  };
};

export default connect(mapStateToProps, { startCapture, finishCapture })(
  CaptureTray
);
